import { BOOKER_EMAIL_QUESTION_ID, BOOKER_PHONE_QUESTION_ID_CHANGA } from '@/constants/constants';
import { AccordionButton, Flex, Icon, IconButton, Text, Tooltip } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { FcFlashAuto } from 'react-icons/fc';
import { FiTrash2 } from 'react-icons/fi';

type IQuestionHeaderProps = {
	id: string;
	label: string;
	isLoading: boolean;
	onDelete: (question: { id: string }) => void;
};

export default function QuestionHeader(props: IQuestionHeaderProps) {
	return (
		<Flex alignItems="center">
			<AccordionButton>
				<Text mr="auto">{props.label}</Text>
			</AccordionButton>
			<ButtonBar {...props} />
		</Flex>
	);
}

function ButtonBar(props: IQuestionHeaderProps) {
	const { t } = useTranslation();

	switch (props.id) {
		case BOOKER_PHONE_QUESTION_ID_CHANGA:
			return (
				<Tooltip label={t('This question was added automatically to let the booker enter their phone number.')}>
					<Flex>
						<Icon cursor="not-allowed" as={FcFlashAuto} w="6" h="6" mr="2" ml="2" />
					</Flex>
				</Tooltip>
			);
		case BOOKER_EMAIL_QUESTION_ID:
			return (
				<Tooltip label={t('This question is required to send the booking confirmation.')}>
					<Flex>
						<Icon cursor="not-allowed" as={FcFlashAuto} w="6" h="6" mr="2" ml="2" />
					</Flex>
				</Tooltip>
			);
		default:
			return (
				<Tooltip label={t('Delete')}>
					<IconButton
						mx="2"
						borderRadius="50%"
						aria-label={t('Delete')}
						icon={<FiTrash2 />}
						colorScheme="red"
						isLoading={props.isLoading}
						onClick={() => props.onDelete({ id: props.id })}
						size="xs"
						variant="outline"
					/>
				</Tooltip>
			);
	}
}
